var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80,
    viewBox: "0 0 1080 1080",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "82963bd8-0923-4f46-b5f3-b6f7f1037608"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(61.27 0 0 60.99 539.66 539.18)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0,0,0)",
      strokeWidth: 0.504,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "evenodd",
      opacity: 1
    },
    transform: " translate(-6.5, -6.5)",
    d: "M 2.29289 2.29289 C 2.68342 1.90237 3.31658 1.90237 3.70711 2.29289 L 6.5 5.08579 L 9.29289 2.29289 C 9.68342 1.90237 10.3166 1.90237 10.7071 2.29289 C 11.0976 2.68342 11.0976 3.31658 10.7071 3.70711 L 7.91421 6.5 L 10.7071 9.29289 C 11.0976 9.68342 11.0976 10.3166 10.7071 10.7071 C 10.3166 11.0976 9.68342 11.0976 9.29289 10.7071 L 6.5 7.91421 L 3.70711 10.7071 C 3.31658 11.0976 2.68342 11.0976 2.29289 10.7071 C 1.90237 10.3166 1.90237 9.68342 2.29289 9.29289 L 5.08579 6.5 L 2.29289 3.70711 C 1.90237 3.31658 1.90237 2.68342 2.29289 2.29289 Z",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/X.ad0cce5aab3477cd7d03f476f68a297f.svg";
export { ForwardRef as ReactComponent };